export const PASSWORD_ERROR = {
    TOO_SHORT: 'Password must be at least 9 characters long',
    MISSING_REQUIRED_CHARACTERS: 'Password must contain at least 1 letter and 1 digit',
};
